/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientPromotionRewardDto } from './clientPromotionRewardDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface ClientPromotionDto { 
    id?: number;
    name?: string;
    description?: string;
    image?: string;
    rules?: string;
    active?: boolean;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    reward?: ClientPromotionRewardDto;
}

